export default __webpack_public_path__ + "static/media/image-homepage-hero.18443de6.jpg";